import { render } from "./coach-dashboard-menu.vue?vue&type=template&id=207a49d1"
import script from "./coach-dashboard-menu.vue?vue&type=script&lang=js"
export * from "./coach-dashboard-menu.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__